import * as React from 'react';
import { Button } from 'antd';
import { default as styled } from 'styled-components';
import { blueColor, borderColor, contentFontColor, lightBlackColor, orangeColor, titleColor, transparentColor, weightBlackColor, whiteColor, whiteGreyLinearColor } from '@config/index';

export const NiButton: typeof Button = styled(Button)`
  &.ant-btn {
    border: 1px solid ${borderColor};
    border-radius: 6px;
    background: ${whiteColor};
    color: ${contentFontColor};
    font-weight: normal;

    &.ant-btn[disabled] {
      cursor: not-allowed;
      background: rgba(0, 0, 0, 0.12);
      color: ${whiteColor};
    }

    &.ant-btn-primary {
      border: 0;
      background: ${blueColor};
      color: ${whiteColor};
    }

    &.ant-btn-danger {
      border: 1px solid ${orangeColor};
      background: ${transparentColor};
      color: ${orangeColor};
    }
  }
` as any;
